import { useEffect, useMemo } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'

import { useWorkspace } from '~/features/workspaces/data.ts'

import { Config } from '../../../../config.ts'
import { isWorkspacelessUrl } from '../../utils/Url.ts'

const { fetch } = window

const config = Config()

// Start impersonating if an admin opens a URL
// of an workspace that they aren't a member of
const AdminAutoImpersonate = () => {
  const { workspace } = useParams<{ workspace: string }>()
  const { data: accountData } = useWorkspace()
  const location = useLocation()

  const shallImpersonate = useMemo(() => {
    return (
      accountData &&
      accountData.isAdmin &&
      !accountData.memberships.find(({ workspace: { slug } }) => slug === workspace)
    )
  }, [accountData, workspace])

  useEffect(() => {
    if (!shallImpersonate) return
    ;(async () => {
      if (!workspace) return
      if (!isWorkspacelessUrl(location.pathname)) return
      const workspaceRes = await fetch(
        `${config.webapiEndpoint}/admin/api/workspaces/view/${workspace}`,
      )
      const body = await workspaceRes.json()
      if (body.meta?.status === 'error') {
        console.error(body.meta.message)
        return
      }

      const impersonateRes = await fetch(
        `${config.webapiEndpoint}/admin/users/impersonate/${body.data.workspace.id}`,
      )
      if (!impersonateRes.ok) {
        throw new Error(await impersonateRes.text())
      }
      window.location.reload()
    })()
  }, [shallImpersonate, workspace, location])

  return shallImpersonate ? null : <Outlet />
}

export default AdminAutoImpersonate
